var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex"},[_c('v-card',{staticClass:"mt-5 sign-in-card"},[_c('SignInForm',{on:{"is-authenticated":_vm.onAuthenticated}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }